import React from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import { resendVerificationEmail } from '../../../actions/auth'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import FtxLogo from '../../../assets/logo/ftx-logo-blue.png'
import './styles.scss'

class PostSignUp extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      busy: false
    }
    this.handleResendClik = this.handleResendClik.bind(this)
  }

  handleResendClik() {
    const { email } = this.props.user
    this.props.resendVerificationEmail({ email })
  }

  on_login = ()=> {
    const { history } = this.props
    history.push('/login')
  }

  render() {
    const { user } = this.props
    if (!user) return <Redirect to='/signup' />
    return (
      <div className="confirmation-sent-container">
        <div className="confirmation-sent">
          <div className="cs-header">
            <h2 className="logo"><span>logo</span></h2>
          </div>
          <div className="cs-body">
            <div className="cs-thanks">
              <p>Thanks for signing up.
              <br/>Please check your inbox!</p>
            </div>
            <div className="cs-ftx-logo">
            <img src={FtxLogo} alt="fTXLogo"/>
            </div>
            <div className="cs-text">
              <p>
                Didn't receive an email from us ? <a href="mailto:support@CloudFlyer.com">Contact Us</a><br/>
               Email confirmation helps us to ensure your data will always be safe
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps({ auth }) {
  return auth
}

function mapDispatchToProps(dispatch) {
  return {
    resendVerificationEmail: bindActionCreators(resendVerificationEmail, dispatch)
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostSignUp))

